import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Validates a URL in a form control.
 */
export function urlValidator(control: AbstractControl): ValidationErrors | null {
    const urlPattern = /(https?:\/\/)?([\da-z.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?(\?[^\s]*)?$/;
    if (!urlPattern.test(control.value)) {
        return { invalidUrl: true };
    }
    return null;
}

/**
 * Validates a URL or "https://" in a form control.
 */
export function urlOrDefaultValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  const urlPattern = /^(https?:\/\/)?((localhost|[\da-z.-]+)(\.[a-z.]{2,6})?|[\da-z.-]+)(:\d{1,5})?(\/[^\s]*)?(\?.*)?$/;

  if (value === 'https://' || (value && urlPattern.test(value))) {
    return null; // Valid URL, "https://", or localhost with optional port
  }
  return { invalidUrlOrDefault: true }; // Invalid URL
}


/**
 * Validates a valid JSON string in a form control.
 */
export function jsonValidator(control: AbstractControl): ValidationErrors | null {
  try {
    if (control.value) {
      JSON.parse(control.value);
    }
    return null; // Empty or Valid JSON
  } catch (e) {
    return { invalidJson: true }; // Invalid JSON
  }
}

export function dateRangeValidator(startDatetimeControlName: string, endDatetimeControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDatetime = new Date(control.get(startDatetimeControlName)?.value);
    const endDatetime = new Date(control.get(endDatetimeControlName)?.value);

    if (startDatetime && endDatetime && startDatetime > endDatetime) {
      return { dateRangeInvalid: true };
    }
    return null;
  };
}
